import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import ProjectApi from "../../api/projectApi";

function AssignedTesting() {
  const navigate = useNavigate();

  const [
    projects,
    setProjects,
  ] = useState([]);

  const [
    loading,
    setLoading,
  ] = useState(true);

  /* =========================================
     FETCH ASSIGNED PROJECTS
  ========================================= */

  const fetchAssignedProjects =
    async () => {
      try {
        setLoading(true);

        const res =
          await ProjectApi.assignedTestingProjects();

        console.log(
          "ASSIGNED TESTING PROJECTS:",
          res
        );

        if (res?.code === 200) {
          const projectData =
            res?.data?.projects ||
            res?.data ||
            [];

          setProjects(
            Array.isArray(projectData)
              ? projectData
              : []
          );
        } else {
          setProjects([]);
        }

      } catch (error) {
        console.error(
          "ASSIGNED TESTING ERROR:",
          error
        );

        setProjects([]);

      } finally {
        setLoading(false);
      }
    };


  useEffect(() => {
    fetchAssignedProjects();
  }, []);


  /* =========================================
     VIEW PROJECT
  ========================================= */

  const handleViewProject =
    (projectId) => {
      navigate(
        `/assigned-testing/${projectId}`
      );
    };


  /* =========================================
     STATUS BADGE
  ========================================= */

  const getStatusBadge =
    (status) => {
      switch (status) {

        case "assigned":
          return (
            <span className="badge bg-warning text-dark">
              Assigned
            </span>
          );

        case "in_testing":
          return (
            <span className="badge bg-primary">
              In Testing
            </span>
          );

        case "bug_found":
          return (
            <span className="badge bg-danger">
              Bug Found
            </span>
          );

        case "retesting":
          return (
            <span className="badge bg-warning text-dark">
              🔄 Retesting Required
            </span>
          );

        case "approved":
          return (
            <span className="badge bg-success">
              Approved
            </span>
          );

        default:
          return (
            <span className="badge bg-secondary">
              {status || "-"}
            </span>
          );
      }
    };


  if (loading) {
    return (
      <div className="content">

        <div className="text-center py-5">
          Loading Assigned Projects...
        </div>

      </div>
    );
  }


  return (
    <div className="content">

      {/* =====================================
          PAGE HEADER
      ====================================== */}

      <div className="mb-4">

        <h3 className="fw-bold mb-1">
          Assigned Testing
        </h3>

        <p className="text-muted mb-0">
          Projects assigned to you for testing
          and retesting
        </p>

      </div>


      {/* =====================================
          PROJECT TABLE
      ====================================== */}

      <div className="card border-0 shadow-sm">

        <div className="card-body p-0">

          <div className="table-responsive">

            <table className="table align-middle mb-0">

              <thead className="table-light">

                <tr>

                  <th className="ps-4">
                    Project
                  </th>

                  <th>
                    Developer
                  </th>

                  <th>
                    Status
                  </th>

                  <th>
                    Testing Status
                  </th>

                  <th className="text-center">
                    Action
                  </th>

                </tr>

              </thead>


              <tbody>

                {projects.length > 0 ? (

                  projects.map(
                    (project) => (

                      <tr
                        key={project?._id}
                      >

                        {/* PROJECT */}

                        <td className="ps-4">

                          <div className="fw-bold">

                            {
                              project?.projectName ||
                              "-"
                            }

                          </div>

                          <small className="text-muted">

                            Priority:{" "}

                            {
                              project?.priority ||
                              "-"
                            }

                          </small>

                        </td>


                        {/* DEVELOPER */}

                        <td>

                          {
                            project
                              ?.assignedDeveloper
                              ?.name ||
                            "-"
                          }

                        </td>


                        {/* PROJECT STATUS */}

                        <td>

                          <span className="badge bg-info">

                            {
                              project?.projectStatus ||
                              "-"
                            }

                          </span>

                        </td>


                        {/* TESTING STATUS */}

                        <td>

                          {
                            getStatusBadge(
                              project?.testingStatus
                            )
                          }

                          {
                            project?.testingStatus ===
                            "retesting" && (

                              <div className="mt-1">

                                <small className="text-warning">

                                  Developer has fixed bugs.
                                  Retesting is required.

                                </small>

                              </div>

                            )
                          }

                        </td>


                        {/* ACTION */}

                        <td className="text-center">

                          <button
                            type="button"
                            className={
                              `btn btn-sm px-3 ${
                                project?.testingStatus ===
                                "retesting"
                                  ? "btn-warning"
                                  : "btn-primary"
                              }`
                            }
                            onClick={() =>
                              handleViewProject(
                                project?._id
                              )
                            }
                          >

                            {
                              project?.testingStatus ===
                              "retesting"
                                ? (
                                  <>
                                    🔄 Retest Now
                                  </>
                                )
                                : (
                                  <>
                                    View Details
                                  </>
                                )
                            }

                          </button>

                        </td>

                      </tr>

                    )
                  )

                ) : (

                  <tr>

                    <td
                      colSpan="5"
                      className="text-center py-5 text-muted"
                    >

                      No projects assigned for testing.

                    </td>

                  </tr>

                )}

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </div>
  );
}

export default AssignedTesting;